import { defineComponent as z, useCssVars as C, computed as m } from "vue";
import { getConfig as p } from "./td-longtail-vue-components2.js";
import { addCdnHost as a } from "./td-longtail-vue-components255.js";
const H = /* @__PURE__ */ z({
  __name: "image-element",
  props: {
    src: { default: void 0 },
    aspectRatio: { default: void 0 },
    imageClass: { default: void 0 },
    imageStyle: { default: void 0 },
    alt: { default: "" },
    lazy: { type: Boolean },
    format: { default: "webp" },
    doNotConvert: { type: Boolean },
    sizes: { default: "" },
    preload: { type: Boolean }
  },
  emits: ["image-error"],
  setup(l, { expose: f }) {
    const e = l;
    C((t, r) => ({
      fbfbebfe: r.aspectRatio
    }));
    const u = m(() => e.aspectRatio), i = (t) => t ? t.split(", ").map((o) => {
      const g = o.trim(), [v, y] = g.split(" ");
      return `${a(v)} ${y}`;
    }).join(", ") : void 0, s = m(() => {
      const { imageOptimizer: t } = p() || {};
      if (e.doNotConvert || !t || !e.src || !e.sizes)
        return {
          src: e.src ? a(e.src) : "",
          type: `image/${e.format}`,
          sizes: void 0,
          srcset: void 0
        };
      const { srcset: r, sizes: d, src: o } = t(e.src, {
        sizes: e.sizes,
        modifiers: {
          format: e.format
        }
      });
      return {
        src: a(o),
        type: `image/${e.format}`,
        sizes: d,
        srcset: i(r)
      };
    }), n = (t) => {
    }, c = p()?.useHead || n;
    return c(() => !e.preload || !s.value?.src ? {} : {
      link: [
        {
          rel: "preload",
          as: "image",
          fetchpriority: "high",
          href: s.value.src || ""
        }
      ]
    }), f({
      defaultImage: s
    }), { __sfc: !0, props: e, aspectRatio: u, processSrcset: i, defaultImage: s, mockUseHead: n, useHead: c };
  }
});
export {
  H as default
};
